import { FC, Fragment } from 'react';
import { Reorder } from 'framer-motion';
import { CustomDRTReportItem } from '../../../utils/models';

import AccordionItem from '../custom-visual-inspection/accordion-item';
import CustomNewItem from '../custom-general/custom-new-item';
import DRTReportForm from '../../forms/custom-drt/drtReportForm';
import EditDRTReportForm from '../../forms/custom-drt/editDRTReportForm';
import Button from '../../themed/button';
import ReorderItem from '../../common/reorderItem';


interface DRTSummaryItemsProps {
	reportItems: CustomDRTReportItem[];
	onDataChange: (items: CustomDRTReportItem[]) => void;
}

const DRTReportItems: FC<DRTSummaryItemsProps> = (props) => {
	const handleAddItem = (reportItem: CustomDRTReportItem) => {
		const newDRTItem = {
			...reportItem,
			id: props.reportItems.length + 1,
		};

		props.onDataChange([...props.reportItems, newDRTItem]);
	};

	const handleDeleteItem = (item: CustomDRTReportItem): void => {
		const newReportItems = props.reportItems.filter((reportItem) => reportItem.id !== item.id);
		props.onDataChange(newReportItems);
	};

	const handleEditItem = (originalItem: CustomDRTReportItem, updatedItem: CustomDRTReportItem): void => {
		const newReportItems = props.reportItems.map((reportItem) => reportItem.id === originalItem.id ? { ...reportItem, ...updatedItem } : reportItem); 
		props.onDataChange(newReportItems);
	};

	const handleDuplicateItem = (item: CustomDRTReportItem, index: number) => {
		const newDRTItem = {
			...item,
			id: props.reportItems.length + 1,
		};

		const newReportItems = [...props.reportItems.slice(0, index), newDRTItem, ...props.reportItems.slice(index)];
		props.onDataChange(newReportItems);
	};

	return (
		<Fragment>
			<CustomNewItem label='Create New DRT Item'>
				<DRTReportForm onAdd={handleAddItem} />
			</CustomNewItem>

			<div className="divider my-4"></div>

			<Reorder.Group className='list-unstyled' values={props.reportItems} onReorder={props.onDataChange}>
				{props.reportItems.map((item, index) => (
					<ReorderItem key={item.id} value={item}>
						<AccordionItem key={item.weldNumber} title={item.weldNumber + ' ' + item.shotNumber} isActive>
							<div className="d-flex justify-content-end align-items-center">
								<div className="bg-light p-2 border rounded">
									<Button
										icon="clipboard-plus-fill"
										label="Duplicate"
										style={{ marginTop: 0 }}
										onClick={() => handleDuplicateItem(item, index)}
									/>
								</div>
							</div>

							<div className="divider my-4"></div>

							<EditDRTReportForm
								reportItem={item}
								onEdit={(updatedItem: CustomDRTReportItem) => handleEditItem(item, updatedItem)}
								onDeleteItem={() => handleDeleteItem(item)}
							/>
						</AccordionItem>
					</ReorderItem>
				))}
			</Reorder.Group>
		</Fragment>
	);
};

export default DRTReportItems;
